import { CheckBox } from "../../core/components/checkBox";
import { DropDownList } from "../../core/components/dropDownList";
import { FieldInstance } from "../../core/components/field";
import { ComponentHelper } from "../../core/util/componentHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { GeneralSettingsAppProps } from "../generalSettings";
import EditDocumentFolderStructureTree, { EditDocumentFolderStructureTreeProps } from "./editDocumentFolderStructureTree";
import React from "react"
interface EditDocumentFolderStructureProps extends GeneralSettingsAppProps {
}

export default class EditDocumentFolderStructure extends React.Component<EditDocumentFolderStructureProps, {
    selectedEntity: DocumentFolderTemplate;
    data: any[];
    documentFolderTemplate: DocumentFolderTemplate[];
}>{
    private _factory = ComponentHelper.createFactory();

    constructor(props) {
        super(props);
        this.state = {
            selectedEntity: null,
            data: [],
            documentFolderTemplate: []
        }
    }

    componentDidMount() {
        this.loadDocumentFolderTemplates();
    }

    private async loadDocumentFolderTemplates() {
        let templates = await HTTPService.get<DocumentFolderTemplate[]>("GeneralSettingsDocumentsFolderStructure/GetDocumentFolderTemplateVms");
        this.setState({ documentFolderTemplate: templates }, () => {
            if (this.state.selectedEntity == null) {
                this.setState({ selectedEntity: this.getDocumentFolderTemplate(-1) })
            }
        });
    }

    private createDropDownList = () => {
        let props = this._factory.getDefaultDropDownProps();
        props.value = this.state.selectedEntity?.EntityId;
        props.dataSource = this.state.documentFolderTemplate;
        props.field.refreshDSOnRefChange = true;
        props.field.dataTextField = "TranslatedEntity";
        props.field.dataValueField = "EntityId";
        props.field.optionLabel = "";
        props.onChange = (_, value: any) => {
            let selectedEntity = this.getDocumentFolderTemplate(value);
            this.setState({ selectedEntity: selectedEntity });
        }

        return (
            <FieldInstance label={Helper.getTranslation("Dokument.DocumentType")} noHover={true}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    private createFolderStructureEnabledCheckBox = () => {
        let props = this._factory.getDefaultCheckBoxProps();
        props.value = this.state.selectedEntity?.FolderStructureEnabled;
        props.onChange = async (_, value: any) => {
            this.state.selectedEntity.FolderStructureEnabled = value;
            let result = await HTTPService.post<JsonResultClass>("GeneralSettingsDocumentsFolderStructure/SaveDocumentFolderTemplate", this.state.selectedEntity);
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }

            this.loadDocumentFolderTemplates();
        };


        return (
            <FieldInstance label={Helper.getTranslation("Dokument.FolderStructureEnabled")} noHover={true}>
                <CheckBox {...props} />
            </FieldInstance>
        );
    }

    private createUseDefaultTemplateCheckBox = () => {
        let props = this._factory.getDefaultCheckBoxProps();
        props.value = this.state.selectedEntity?.UseDefaultTemplate;
        props.onChange = async (_, value: any) => {
            this.state.selectedEntity.UseDefaultTemplate = value;
            let result = await HTTPService.post<JsonResultClass>("GeneralSettingsDocumentsFolderStructure/SaveDocumentFolderTemplate", this.state.selectedEntity);
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }

            this.loadDocumentFolderTemplates();
        };

        return (
            <FieldInstance label={Helper.getTranslation("Dokument.UseDefaultTemplate")} noHover={true}>
                <CheckBox {...props} />
            </FieldInstance>
        );
    }

    private getDocumentFolderTemplate = (entityId: number): DocumentFolderTemplate => {
        return this.state.documentFolderTemplate.find(x => x.EntityId == entityId);
    }

    private getDocumentFolderStructureTree = () => {
        let props: EditDocumentFolderStructureTreeProps = {
            documentFolderTemplate: this.state.selectedEntity
        };

        return <EditDocumentFolderStructureTree {...props} />
    }

    render() {
        let showCheckBoxes = Helper.hasValue(this.state.selectedEntity) && this.state.selectedEntity.EntityId != -1

        return (<>
            {this.createDropDownList()}
            {showCheckBoxes ? this.createFolderStructureEnabledCheckBox() : null}
            {showCheckBoxes ? this.createUseDefaultTemplateCheckBox() : null}
            {this.getDocumentFolderStructureTree()}
        </>)
    }
}

export interface DocumentFolderTemplate {
    EntityId?: number;
    Entity?: string;
    TranslatedEntity?: string;
    FolderStructureEnabled?: boolean;
    UseDefaultTemplate?: boolean;
}